import type { SVGProps } from 'react';
const SvgMode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Mode_svg__a)">
      <path
        d="M8 3.922V1.203m0 2.719c1.082 0 2.119.43 2.884 1.195M8 3.922c-1.082 0-2.119.43-2.884 1.195m0 0L3.194 3.194m1.922 1.923A4.08 4.08 0 0 0 3.922 8m0 0H1.203m2.719 0c0 1.082.43 2.119 1.194 2.884m0 0-1.922 1.922m1.922-1.922A4.08 4.08 0 0 0 8 12.078m-2.884-1.194a4.08 4.08 0 0 1 1.365-6.67 4.08 4.08 0 0 0 5.304 5.305 4.08 4.08 0 0 1-6.669 1.365M8 12.078v2.719m0-2.719c1.082 0 2.119-.43 2.884-1.194m0 0 1.922 1.922m-1.922-1.922A4.08 4.08 0 0 0 12.078 8m0 0h2.719m-2.719 0c0-1.082-.43-2.118-1.194-2.883m0 0 1.922-1.923"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Mode_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMode;
